var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"title":_vm.$t('Send Credits'),"hide-footer":"","centered":"","no-close-on-esc":""},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[(_vm.sendAmount)?_c('div',[_c('send-credit-confirm')],1):_c('div',[_c('send-credit-amount')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }